import { AuthFetchBlob } from "../hooks/useApi";
import { GuiaInternacaoPayload, OpmePayload, ResumoPayload } from "../types/pdf.types";
import { RecursoFinal } from "../types/resources.types";

export const pdfService = {
  downloadOpme: (
    apiFetchBlob: AuthFetchBlob,
    payload: OpmePayload,
  ): Promise<Blob> =>
    apiFetchBlob("/guia_de_opme/pdf", {
      method: "POST",
      body: JSON.stringify(payload),
    }),

  downloadGuiaInternacao: (
    apiFetchBlob: AuthFetchBlob,
    payload: GuiaInternacaoPayload,
  ): Promise<Blob> =>
    apiFetchBlob("/guia_de_internacao/pdf", {
      method: "POST",
      body: JSON.stringify(payload),
    }),

  downloadResumo: (
    apiFetchBlob: AuthFetchBlob,
    payload: ResumoPayload,
  ): Promise<Blob> =>
    apiFetchBlob("/resumo/pdf", {
      method: "POST",
      body: JSON.stringify(payload),
    }),
  
  downloadRecurso: (
    apiFetchBlob: AuthFetchBlob,
    payload: RecursoFinal,
  ): Promise<Blob> => 
    apiFetchBlob("/recursos/pdf", {
      method: "POST",
      body: JSON.stringify(payload),
    })
};
